module.exports = __webpack_public_path__ + "static/media/Logo-fc-analise-so-fc.54fb6418.png";